import { createAction } from "redux-actions";

export const getBranches = createAction("GET_BRANCHES");
export const setBranches = createAction("SET_BRANCHES");
